// extracted by mini-css-extract-plugin
export default {"quantityLabel":"styles_quantityLabel__Bjw4A","iconTooltip":"styles_iconTooltip__vG0P6","required":"styles_required__ZeAHi"};